/**
 *  @class
 *  @function VerticalSlideshow
 */
if (!customElements.get('vertical-slideshow')) {
  class VerticalSlideshow extends HTMLElement {
    constructor() {
      super();
      let section = this;

      this.parent_section = this.closest('.shopify-section');
      this.slides = Array.from(section.querySelectorAll('.vertical-slideshow--slide'));
      this.dots = section.querySelector('.vertical-slideshow-dots');
      this.dots_li = this.dots?.querySelectorAll('li');
      this.animations = [];
      this.animations_enabled =
        document.body.classList.contains('animations-true') &&
        typeof gsap !== 'undefined';

      // >>> ADDED: durum ve yardımcı alanlar
      this.spacers = [];
      this.isSnapping = false;
      this.touchStartY = 0;
      this.touchLastY = 0;

      // >>> ADDED: mobilde micro-swipe tetiklemek için
      this.touchTriggered = false;

      // >>> FIXED: visibility class ekle (DOM SİLME YOK)
      this.slides.forEach((slide) => {
        const showDesktop = slide.dataset.showDesktop !== 'false';
        const showMobile = slide.dataset.showMobile !== 'false';

        if (!showDesktop) slide.classList.add('hide-desktop');
        if (!showMobile) slide.classList.add('hide-mobile');
      });
    }

    connectedCallback() {
      document.addEventListener('DOMContentLoaded', () => {
        this.setupScrolling();
      });
    }

    setupScrolling() {
      let video_containers = [];

      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      // >>> FIXED: SADECE GSAP İÇİN AKTİF SLIDE LİSTESİ
      const gsapSlides = this.slides.filter((slide) => {
        if (isMobile) return !slide.classList.contains('hide-mobile');
        return !slide.classList.contains('hide-desktop');
      });

      // >>> GSAP SADECE BU LİSTEYİ BİLİR
      gsapSlides.forEach((slide, i) => {
        const endInfo = gsapSlides.length - 1 === i ? 'top top' : 'bottom top';
        video_containers.push(
          slide.querySelector('.vertical-slideshow--slide-video-bg')
        );

        const instance = ScrollTrigger.create({
          trigger: slide,
          start: 'top top',
          end: endInfo,
          pin: true,
          anticipatePin: 1,

          // >>> FIXED: Mobilde snap AÇIK ve hızlı, Desktop’ta normal
          snap: isMobile
            ? {
                snapTo: [0, 1],
                duration: 0.18,
                delay: 0,
                inertia: false
              }
            : {
                snapTo: [0, 1],
                duration: 0.5,
                delay: 0.2,
                inertia: false
              },

          pinSpacing: false,
          onUpdate: (self) => {
            if (gsapSlides.length - 1 !== i) {
              // self.pin.style.setProperty(
              //   '--snap-overlay-opacity',
              //   self.progress.toFixed(3)
              // );
              // self.pin.style.setProperty(
              //   '--snap-content-opacity',
              //   1 - self.progress.toFixed(3)
              // );
            }

            if (self.direction === -1 && self.progress < 0.3) {
              if (video_containers[i]) this.videoPlay(video_containers[i]);
              if (video_containers[i + 1]) this.videoPause(video_containers[i + 1]);
              if (video_containers[i - 1]) this.videoPause(video_containers[i - 1]);
            } else if (
              self.direction === 1 &&
              self.progress > 0.3 &&
              self.progress < 1
            ) {
              if (video_containers[i]) this.videoPause(video_containers[i]);
              if (video_containers[i - 1]) this.videoPause(video_containers[i - 1]);
              if (video_containers[i + 1]) this.videoPlay(video_containers[i + 1]);
            } else {
              if (this.dots_li) this.toggleDotClass(i);
            }
          }
        });

        // >>> ADDED: GSAP snap devre dışı (kodu silmeden)
        // >>> FIXED: SADECE DESKTOP’TA devre dışı bırak
        if (!isMobile && instance && instance.vars && instance.vars.snap) {
          instance.vars.snap = false;
        }
      });

      setTimeout(() => {

        this.refreshSpacers();

        this.addEventListener(
          'touchstart',
          (e) => {
            this.touchStartY = e.touches[0].clientY;
            this.touchLastY = this.touchStartY;

            // >>> ADDED: her dokunuşta sıfırla
            this.touchTriggered = false;
          },
          { passive: true }
        );

        this.addEventListener('touchmove', this.onTouchMove.bind(this), {
          passive: false
        });

        this.addEventListener('touchend', this.onTouchEnd.bind(this), {
          passive: true
        });

      }, 10);
    }

    // >>> SPACER
    refreshSpacers() {
      this.spacers = Array.from(this.querySelectorAll('.pin-spacer'));
      if (!this.spacers.length) this.spacers = this.slides;
    }

    getIndexFromScroll() {
      const sy = window.scrollY;
      let best = { idx: 0, d: Infinity };
      this.spacers.forEach((sp, i) => {
        const top = sp.getBoundingClientRect().top + window.scrollY;
        const d = Math.abs(sy - top);
        if (d < best.d) best = { idx: i, d };
      });
      return best.idx;
    }

    snapToIndex(targetIndex) {
      if (this.isSnapping) return;
      const sp = this.spacers[targetIndex];
      if (!sp) return;

      this.isSnapping = true;

      window.scrollTo({
        top: sp.getBoundingClientRect().top + window.scrollY,
        behavior: 'smooth'
      });

      setTimeout(() => (this.isSnapping = false), 260);
    }

    onTouchMove(e) {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      if (!isMobile) return;

      this.touchLastY = e.touches[0].clientY;
      const delta = this.touchStartY - this.touchLastY;

      // >>> ADDED: en ufak swipe (2px) = direkt geçiş
      if (!this.touchTriggered && Math.abs(delta) >= 2) {

        this.refreshSpacers();
        const currentIndex = this.getIndexFromScroll();
        const lastIndex = this.spacers.length - 1;

        // >>> ADDED: SON SLIDE + AŞAĞI SWIPE → normal scroll’a izin ver
        if (currentIndex === lastIndex && delta > 0) {
          return;
        }

        // >>> ADDED: İLK SLIDE + YUKARI SWIPE → normal scroll’a izin ver
        if (currentIndex === 0 && delta < 0) {
          return;
        }

        this.touchTriggered = true;

        e.preventDefault();

        let targetIndex = delta > 0 ? currentIndex + 1 : currentIndex - 1;
        targetIndex = Math.max(0, Math.min(targetIndex, lastIndex));

        this.snapToIndex(targetIndex);
      }
    }

    onTouchEnd() {
      // >>> ADDED: touch end’de sadece reset
      this.touchStartY = 0;
      this.touchLastY = 0;
      this.touchTriggered = false;
    }

    toggleDotClass(i) {
      [].forEach.call(this.dots_li, (el) =>
        el.classList.remove('is-selected')
      );
      if (this.dots_li[i]) this.dots_li[i].classList.add('is-selected');
    }

    videoPause(video_container) {
      if (video_container && !video_container.querySelector('video').paused) {
        video_container.querySelector('video').pause();
      }
    }

    videoPlay(video_container) {
      if (video_container && video_container.querySelector('video').paused) {
        video_container.querySelector('video').play();
      }
    }
  }

  customElements.define('vertical-slideshow', VerticalSlideshow);
}


// en yeni eski hali

// /**
//  *  @class
//  *  @function VerticalSlideshow
//  */
// if (!customElements.get('vertical-slideshow')) {
//   class VerticalSlideshow extends HTMLElement {
//     constructor() {
//       super();
//       let section = this;

//       this.parent_section = this.closest('.shopify-section');
//       this.slides = Array.from(section.querySelectorAll('.vertical-slideshow--slide'));
//       this.dots = section.querySelector('.vertical-slideshow-dots');
//       this.dots_li = this.dots?.querySelectorAll('li');
//       this.animations = [];
//       this.animations_enabled =
//         document.body.classList.contains('animations-true') &&
//         typeof gsap !== 'undefined';

//       // >>> ADDED: durum ve yardımcı alanlar
//       this.spacers = [];
//       this.isSnapping = false;
//       this.touchStartY = 0;
//       this.touchLastY = 0;

//       // >>> FIXED: visibility class ekle (DOM SİLME YOK)
//       this.slides.forEach((slide) => {
//         const showDesktop = slide.dataset.showDesktop !== 'false';
//         const showMobile = slide.dataset.showMobile !== 'false';

//         if (!showDesktop) slide.classList.add('hide-desktop');
//         if (!showMobile) slide.classList.add('hide-mobile');
//       });
//     }

//     connectedCallback() {
//       document.addEventListener('DOMContentLoaded', () => {
//         this.setupScrolling();
//       });
//     }

//     setupScrolling() {
//       let video_containers = [];

//       const isMobile = window.matchMedia('(max-width: 767px)').matches;

//       // >>> FIXED: SADECE GSAP İÇİN AKTİF SLIDE LİSTESİ
//       const gsapSlides = this.slides.filter((slide) => {
//         if (isMobile) return !slide.classList.contains('hide-mobile');
//         return !slide.classList.contains('hide-desktop');
//       });

//       // >>> GSAP SADECE BU LİSTEYİ BİLİR
//       gsapSlides.forEach((slide, i) => {
//         const endInfo = gsapSlides.length - 1 === i ? 'top top' : 'bottom top';
//         video_containers.push(
//           slide.querySelector('.vertical-slideshow--slide-video-bg')
//         );

//         const instance = ScrollTrigger.create({
//           trigger: slide,
//           start: 'top top',
//           end: endInfo,
//           pin: true,
//           anticipatePin: 1,
//           snap: {
//             snapTo: [0, 1],
//             duration: 0.5,
//             delay: 0.2,
//             inertia: false
//           },
//           pinSpacing: false,
//           onUpdate: (self) => {
//           if (gsapSlides.length - 1 !== i) {
//   // self.pin.style.setProperty(
//   //   '--snap-overlay-opacity',
//   //   self.progress.toFixed(3)
//   // );
//   // self.pin.style.setProperty(
//   //   '--snap-content-opacity',
//   //   1 - self.progress.toFixed(3)
//   // );
// }

//             if (self.direction === -1 && self.progress < 0.3) {
//               if (video_containers[i]) this.videoPlay(video_containers[i]);
//               if (video_containers[i + 1]) this.videoPause(video_containers[i + 1]);
//               if (video_containers[i - 1]) this.videoPause(video_containers[i - 1]);
//             } else if (
//               self.direction === 1 &&
//               self.progress > 0.3 &&
//               self.progress < 1
//             ) {
//               if (video_containers[i]) this.videoPause(video_containers[i]);
//               if (video_containers[i - 1]) this.videoPause(video_containers[i - 1]);
//               if (video_containers[i + 1]) this.videoPlay(video_containers[i + 1]);
//             } else {
//               if (this.dots_li) this.toggleDotClass(i);
//             }
//           }
//         });

//         // >>> ADDED: GSAP snap devre dışı (kodu silmeden)
//         if (instance && instance.vars && instance.vars.snap) {
//           instance.vars.snap = false;
//         }
//       });

//       // >>> FIXED: DOT SAYISI SADECE AKTİF SLIDE SAYISINA GÖRE
//       if (this.dots) {
//         const ol = this.dots.querySelector('ol') || this.dots;
//         const dots = Array.from(ol.querySelectorAll('li'));

//         if (gsapSlides.length <= 1) {
//           this.dots.style.display = 'none';
//         } else {
//           dots.forEach((dot, idx) => {
//             if (idx >= gsapSlides.length) dot.remove();
//           });
//           this.dots_li = this.dots.querySelectorAll('li');
//         }
//       }

//       window.addEventListener(
//         'scroll',
//         () => {
//           let top = this.getBoundingClientRect().top + window.scrollY;
//           if (window.scrollY > top + this.offsetHeight - 100) {
//             this.videoPause(video_containers[gsapSlides.length - 1]);
//           }
//         },
//         { passive: true }
//       );

//       setTimeout(() => {
//         if (this.dots_li) {
//           Array.from(this.dots_li).forEach((dot, index) => {
//             dot.addEventListener('click', () => {
//               this.refreshSpacers();
//               this.snapToIndex(index);
//             });
//           });
//         }

//         this.refreshSpacers();
//         this.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
//         this.addEventListener(
//           'touchstart',
//           (e) => {
//             this.touchStartY = e.touches[0].clientY;
//             this.touchLastY = this.touchStartY;
//           },
//           { passive: true }
//         );
//         this.addEventListener('touchmove', this.onTouchMove.bind(this), {
//           passive: false
//         });
//         this.addEventListener('touchend', this.onTouchEnd.bind(this), {
//           passive: false
//         });
//       }, 10);
//     }

//     // >>> SPACER
//     refreshSpacers() {
//       this.spacers = Array.from(this.querySelectorAll('.pin-spacer'));
//       if (!this.spacers.length) this.spacers = this.slides;
//     }

//     getIndexFromScroll() {
//       const sy = window.scrollY;
//       let best = { idx: 0, d: Infinity };
//       this.spacers.forEach((sp, i) => {
//         const top = sp.getBoundingClientRect().top + window.scrollY;
//         const d = Math.abs(sy - top);
//         if (d < best.d) best = { idx: i, d };
//       });
//       return best.idx;
//     }

//     snapToIndex(targetIndex) {
//       if (this.isSnapping) return;
//       const sp = this.spacers[targetIndex];
//       if (!sp) return;

//       this.isSnapping = true;
//       window.scrollTo({
//         top: sp.getBoundingClientRect().top + window.scrollY,
//         behavior: 'smooth'
//       });
//       setTimeout(() => (this.isSnapping = false), 600);
//     }

//     onWheel(e) {
//       if (this.isSnapping) e.preventDefault();
//     }

//     onTouchMove(e) {
//       if (this.isSnapping) e.preventDefault();
//     }

//     onTouchEnd() {
//       this.touchStartY = 0;
//     }

//     toggleDotClass(i) {
//       [].forEach.call(this.dots_li, (el) =>
//         el.classList.remove('is-selected')
//       );
//       if (this.dots_li[i]) this.dots_li[i].classList.add('is-selected');
//     }

//     videoPause(video_container) {
//       if (video_container && !video_container.querySelector('video').paused) {
//         video_container.querySelector('video').pause();
//       }
//     }

//     videoPlay(video_container) {
//       if (video_container && video_container.querySelector('video').paused) {
//         video_container.querySelector('video').play();
//       }
//     }
//   }

//   customElements.define('vertical-slideshow', VerticalSlideshow);
// }







/**
 *  @class
 *  @function VerticalSlideshow
 */
/*eski hali
if (!customElements.get('vertical-slideshow')) {
  class VerticalSlideshow extends HTMLElement {
    constructor() {
      super();
      let section = this;

      this.parent_section = this.closest('.shopify-section');
      this.slides = Array.from(section.querySelectorAll('.vertical-slideshow--slide'));
      this.dots = section.querySelector('.vertical-slideshow-dots');
      this.dots_li = this.dots?.querySelectorAll('li');
      this.animations = [];
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

      // >>> ADDED: durum ve yardımcı alanlar
      this.spacers = [];
      this.isSnapping = false;     // animasyon kilidi
      this.touchStartY = 0;
      this.touchLastY = 0;         // >>> ADDED
    }
    connectedCallback() {
      document.addEventListener('DOMContentLoaded', this.setupScrolling.bind(this));
    }
    setupScrolling() {
      let video_containers = [];
      this.slides.forEach((slide, i) => {
        const length = this.slides.length;
        const endInfo = this.slides.length - 1 === i ? "top top" : "bottom top";
        video_containers.push(slide.querySelector('.vertical-slideshow--slide-video-bg'));

        const instance = ScrollTrigger.create({
          trigger: slide,
          start: "top top",
          end: endInfo,
          pin: true,
          anticipatePin: 1,
          snap: {
            snapTo: [0, 1],
            duration: 0.5,
            delay: 0.2,
            inertia: false,
          },
          pinSpacing: false,
          onUpdate: self => {
            if (this.slides.length - 1 !== i) {
              self.pin.style.setProperty('--snap-overlay-opacity', self.progress.toFixed(3));
              self.pin.style.setProperty('--snap-content-opacity', 1 - self.progress.toFixed(3));
            }
            if (self.direction == -1 && self.progress < 0.3) {

              if (video_containers[i]) {
                this.videoPlay(video_containers[i]);
              }
              if (video_containers[i + 1]) {
                this.videoPause(video_containers[i + 1]);
              }
              if (video_containers[i - 1]) {
                this.videoPause(video_containers[i - 1]);
              }

            } else if (self.direction == 1 && self.progress > 0.3 && self.progress < 1) {

              if (video_containers[i]) {
                this.videoPause(video_containers[i]);
              }
              if (video_containers[i - 1]) {
                this.videoPause(video_containers[i - 1]);
              }
              if (video_containers[i + 1]) {
                this.videoPlay(video_containers[i + 1]);
              }
            } else {
              if (this.dots_li) {
                this.toggleDotClass(i);
              }
            }
          }
        });

        // >>> ADDED: GSAP’in kendi snap’ini devre dışı bırak (kodu silmeden)
        if (instance && instance.vars && instance.vars.snap) {
          instance.vars.snap = false;
        }
      });

      window.addEventListener('scroll', () => {
        let top = this.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > top + this.offsetHeight - 100) {
          this.videoPause(video_containers[this.slides.length - 1]);
        }
      }, {
        passive: true
      });

      setTimeout(() => {
        if (this.dots_li) {
          Array.from(this.dots_li).forEach((dot, index) => {
            dot.addEventListener('click', this.onDotClick.bind(this, dot, index));
          });
        }

        // >>> ADDED: spacer’ları topla ve “tık tık” davranışı için dinleyicileri ekle
        this.refreshSpacers();
        this.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
        this.addEventListener('touchstart', (e) => { this.touchStartY = e.touches[0].clientY; this.touchLastY = this.touchStartY; }, { passive: true }); // >>> CHANGED: touchLastY eklendi
        this.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: false }); // >>> ADDED
        this.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: false });
      }, 10);
    }

    // >>> ADDED: spacer’ları bul (GSAP pin-spacer) ve yedekle
    refreshSpacers() {
      this.spacers = Array.from(this.querySelectorAll('.pin-spacer'));
      if (!this.spacers.length && this.parentNode?.querySelectorAll) {
        const all = Array.from(this.parentNode.querySelectorAll('.pin-spacer'));
        // sadece bu bölümle ilişkili olanları filtrele
        this.spacers = all.filter(sp => sp.querySelector && sp.querySelector('[is="vertical-slideshow"], vertical-slideshow') ? sp.querySelector('[is="vertical-slideshow"], vertical-slideshow') === this : sp.contains(this));
      }
      if (!this.spacers.length) {
        // fallback: slaytların kendisi
        this.spacers = this.slides;
      }
    }

    // >>> ADDED: mevcut scroll’a en yakın index
    getIndexFromScroll() {
      const sy = window.scrollY;
      let best = { idx: 0, d: Infinity };
      this.spacers.forEach((sp, i) => {
        const top = sp.getBoundingClientRect().top + window.scrollY;
        const d = Math.abs(sy - top);
        if (d < best.d) best = { idx: i, d };
      });
      return best.idx;
    }

    // >>> ADDED: kısa, yumuşak kaydırma animasyonu (yaklaşık 0.55s), animasyon kilidi ile
    snapToIndex(targetIndex) {
      if (this.isSnapping) return;
      const sp = this.spacers[targetIndex];
      if (!sp) return;

      this.isSnapping = true;

      const startY = window.scrollY;
      const endY = sp.getBoundingClientRect().top + window.scrollY;
      const duration = 550; // ms
      const startTime = performance.now();
      const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

      // animasyon sırasında ek scroll’u blokla
      const block = (e) => { e.preventDefault(); };
      window.addEventListener('wheel', block, { passive: false });
      window.addEventListener('touchmove', block, { passive: false });

      const step = (now) => {
        const t = Math.min(1, (now - startTime) / duration);
        const eased = easeOutCubic(t);
        const y = Math.round(startY + (endY - startY) * eased);
        window.scrollTo(0, y);
        if (t < 1) {
          requestAnimationFrame(step);
        } else {
          window.removeEventListener('wheel', block);
          window.removeEventListener('touchmove', block);
          setTimeout(() => { this.isSnapping = false; }, 120);
        }
      };
      requestAnimationFrame(step);
    }

    // >>> ADDED: wheel davranışı — sınırlar hariç default’a izin ver
    onWheel(e) {
      // Bölüm görünmüyorsa engelleme
      const rect = this.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

      if (this.isSnapping) { e.preventDefault(); return; }

      const dir = e.deltaY > 0 ? 1 : -1;
      const cur = this.getIndexFromScroll();

      // SON SLIDE AŞAĞI veya İLK SLIDE YUKARI -> default scroll’a izin ver
      if ((dir === 1 && cur === this.spacers.length - 1) ||
          (dir === -1 && cur === 0)) {
        // izin ver: prevent etme, çıkış serbest
        return;
      }

      e.preventDefault();
      const next = Math.min(Math.max(cur + dir, 0), this.spacers.length - 1);
      if (next !== cur) this.snapToIndex(next);
    }

    // >>> ADDED: dokunmatik sırasında UA scroll'unu section içinde tut
    onTouchMove(e) {
      // bölüm görünmüyorsa bloklama
      const rect = this.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

      if (this.isSnapping) { e.preventDefault(); return; }
      if (!e.touches || !e.touches.length) return;

      const y = e.touches[0].clientY;
      const dir = (this.touchStartY - y) > 0 ? 1 : -1; // 1: aşağı, -1: yukarı
      const cur = this.getIndexFromScroll();
      const last = this.spacers.length - 1;

      // İlk/son slaytta ilgili yönde isek -> sayfaya izin ver (diğer section'a geçebilsin)
      if ((dir === 1 && cur === last) || (dir === -1 && cur === 0)) {
        this.touchLastY = y;
        return; // prevent yok, doğal scroll devam
      }

      // Aksi halde (section içindeyiz) UA scroll'unu durdur
      e.preventDefault();
      this.touchLastY = y;
    }

    // >>> ADDED: dokunmatik
    onTouchEnd(e) {
      if (!this.touchStartY) return;
      if (this.isSnapping) { e.preventDefault(); return; }

      const endY = (e.changedTouches && e.changedTouches[0]?.clientY) || 0;
      const delta = this.touchStartY - endY;

      if (Math.abs(delta) < 30) return; // küçük dokunuşları yoksay

      const dir = delta > 0 ? 1 : -1;
      const cur = this.getIndexFromScroll();

      // SON/ILK sınırlarında default’a izin ver
      if ((dir === 1 && cur === this.spacers.length - 1) ||
          (dir === -1 && cur === 0)) {
        // prevent yok: sayfa akmaya devam etsin
        this.touchStartY = 0;
        return;
      }

      e.preventDefault();
      const next = Math.min(Math.max(cur + dir, 0), this.spacers.length - 1);
      if (next !== cur) this.snapToIndex(next);

      this.touchStartY = 0;
    }

    toggleDotClass(i) {
      [].forEach.call(this.dots_li, function (el) {
        el.classList.remove('is-selected');
      });
      this.dots_li[i].classList.add('is-selected');
    }
    onDotClick(dot, index) {

      let spacers = this.querySelectorAll('.pin-spacer'),
        top = spacers[index].getBoundingClientRect().top + window.scrollY;

      // >>> CHANGED: dot tıklaması da bizim kısa animasyonla gitsin
      this.refreshSpacers();
      this.snapToIndex(index);
      // eski smooth scroll’u SİLMEDİM; ama çalışmaması için yorum satırı değil, snapToIndex önce çalışıyor.
      // window.scrollTo({ top: top, left: 0, behavior: "smooth" });
    }
    videoPause(video_container) {
      if (video_container && !video_container.querySelector('video').paused) {
        video_container.querySelector('video').pause();
      }
    }
    videoPlay(video_container) {
      if (video_container && video_container.querySelector('video').paused) {
        video_container.querySelector('video').play();
      }
    }
  }
  customElements.define('vertical-slideshow', VerticalSlideshow);
} 
 */



/**
 *  @class
 *  @function VerticalSlideshow
 */
/*eski hali
if (!customElements.get('vertical-slideshow')) {
  class VerticalSlideshow extends HTMLElement {
    constructor() {
      super();
      let section = this;

      this.parent_section = this.closest('.shopify-section');
      this.slides = Array.from(section.querySelectorAll('.vertical-slideshow--slide'));
      this.dots = section.querySelector('.vertical-slideshow-dots');
      this.dots_li = this.dots?.querySelectorAll('li');
      this.animations = [];
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      document.addEventListener('DOMContentLoaded', this.setupScrolling.bind(this));
    }
    setupScrolling() {
      let video_containers = [];
      this.slides.forEach((slide, i) => {
        const length = this.slides.length;
        const endInfo = this.slides.length - 1 === i ? "top top" : "bottom top";
        video_containers.push(slide.querySelector('.vertical-slideshow--slide-video-bg'));

        const instance = ScrollTrigger.create({
          trigger: slide,
          start: "top top",
          end: endInfo,
          pin: true,
          anticipatePin: 1,
          snap: {
            snapTo: [0, 1],
            duration: 0.5,
            delay: 0.2,
            inertia: false,
          },
          pinSpacing: false,
          onUpdate: self => {
            if (this.slides.length - 1 !== i) {
              self.pin.style.setProperty('--snap-overlay-opacity', self.progress.toFixed(3));
              self.pin.style.setProperty('--snap-content-opacity', 1 - self.progress.toFixed(3));
            }
            if (self.direction == -1 && self.progress < 0.3) {

              if (video_containers[i]) {
                this.videoPlay(video_containers[i]);
              }
              if (video_containers[i + 1]) {
                this.videoPause(video_containers[i + 1]);
              }
              if (video_containers[i - 1]) {
                this.videoPause(video_containers[i - 1]);
              }

            } else if (self.direction == 1 && self.progress > 0.3 && self.progress < 1) {

              if (video_containers[i]) {
                this.videoPause(video_containers[i]);
              }
              if (video_containers[i - 1]) {
                this.videoPause(video_containers[i - 1]);
              }
              if (video_containers[i + 1]) {
                this.videoPlay(video_containers[i + 1]);
              }
            } else {
              if (this.dots_li) {
                this.toggleDotClass(i);
              }
            }
          }
        });

      });
      window.addEventListener('scroll', () => {
        let top = this.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > top + this.offsetHeight - 100) {
          this.videoPause(video_containers[this.slides.length - 1]);
        }
      }, {
        passive: true
      });
      setTimeout(() => {
        if (this.dots_li) {
          Array.from(this.dots_li).forEach((dot, index) => {
            dot.addEventListener('click', this.onDotClick.bind(this, dot, index));
          });
        }
      }, 10);
    }
    toggleDotClass(i) {
      [].forEach.call(this.dots_li, function (el) {
        el.classList.remove('is-selected');
      });
      this.dots_li[i].classList.add('is-selected');
    }
    onDotClick(dot, index) {

      let spacers = this.querySelectorAll('.pin-spacer'),
        top = spacers[index].getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth"
      });
    }
    videoPause(video_container) {
      if (video_container && !video_container.querySelector('video').paused) {
        video_container.querySelector('video').pause();
      }
    }
    videoPlay(video_container) {
      if (video_container.querySelector('video').paused) {
        video_container.querySelector('video').play();
      }
    }
  }
  customElements.define('vertical-slideshow', VerticalSlideshow);
}
*/